import styled from '@emotion/styled';
import { colors } from 'crono-fe-common/theme';

export const NotEnoughCreditsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-radius: 8px;
  background-color: ${colors.inactiveLight};
  color: ${colors.inactiveHover};
  padding: 4px 4px 4px 12px;

  .buy-button:hover {
    background-color: ${colors.inactive} !important;
  }
`;
